import "./../../bindings/bao-tree";
import * as ko from "knockout";
import Bao from "./../../services/bao-service";
import baoRouter from "./../../services/bao-router";
import BaoMenu from "./../../services/bao-menu";
import BaoDialog from "./../../factories/bao-dialog";
import SubscriptionViewModel from "./../../factories/subscription-view-model";
import TreeNodeViewModel from "./../../factories/tree-node";
import Guid from "./../../factories/guid";
function AllCategoryViewModel(tabPage) {
    var self = this;
    SubscriptionViewModel.call(this, tabPage);
    self.Nodes = ko.observableArray([]);
    self.SelectedNode = ko.observable();
    self.subscribe(self.SelectedNode, function () {
        self.toggleButtons();
    });
    BaoMenu.registerEvent(function (value) {
        if (tabPage.IsActiveTab()) {
            switch (value.ActionKey()) {
                case "CategoryNew":
                    self.add();
                    break;
                case "CategoryEdit":
                    self.edit();
                    break;
                case "CategoryDelete":
                    self["delete"]();
                    break;
                case "CategoryRefresh":
                    self.refresh();
                    break;
            }
        }
    });
    self.toggleButtons = function () {
        var enabled = self.SelectedNode() != null;
        BaoMenu.permissionEnable({ ActionKey: "CategoryNew", Enabled: enabled && self.SelectedNode().Level() < 5, Context: tabPage.Context() });
        BaoMenu.permissionEnable({ ActionKey: "CategoryEdit", Enabled: enabled, Context: tabPage.Context() });
        BaoMenu.permissionEnable({ ActionKey: "CategoryDelete", Enabled: enabled, Context: tabPage.Context() });
    };
    self.add = function () {
        baoRouter.setHash('masterdata/category/' + Guid() + '/' + self.SelectedNode().Tag());
    };
    self.edit = function () {
        baoRouter.setHash('masterdata/category/' + self.SelectedNode().Tag());
    };
    self["delete"] = function () {
        if (self.SelectedNode()) {
            var yesNoDialog = new BaoDialog(Bao.Session.ApplicationName, Bao.Session.GetMessage('msgDelete'), "yesno");
            yesNoDialog.DialogResult.subscribe(function (result) {
                if (result === true) {
                    self.TabPage.IsLoading(true);
                    return Bao.post('masterdata/category/delete', JSON.stringify({
                        id: self.SelectedNode().Tag()
                    })).then(function () {
                        self.refresh();
                    });
                }
            });
        }
    };
    self.refresh = function () {
        tabPage.IsLoading(true);
        var lastSelectedNode = self.SelectedNode();
        return Bao.post('masterdata/category/getall', function (result) {
            var newItems = [];
            if (result != null && result.length > 0) {
                $.each(result, function (index, row) {
                    var node = new TreeNodeViewModel(row);
                    newItems[index] = node;
                });
                tabPage.Title(result[0].Text);
            }
            self.Nodes(newItems);
            self.selectNode(lastSelectedNode);

            tabPage.IsLoading(false);
        });
    };
    self.sortNodes = function (nodesArray) {
        nodesArray.sort(function (itemA, itemB) {
            var textA = itemA.Text().toLowerCase();
            var textB = itemB.Text().toLowerCase();
            return textA == textB ? 0 : (textA < textB ? -1 : 1);
        });
    };
    self.expandNode = function (node) {
        node.Expanded(true);
        if (node.Parent) {
            self.expandNode(node.Parent);
        }
    };
    self.selectNode = function (node) {
        if (node) {
            var nodeFound = self.findNode(self.Nodes(), node);
            if (nodeFound) {
                self.SelectedNode(nodeFound);
                self.expandNode(nodeFound);
            }
            else {
                self.SelectedNode(null);
            }
        }
    };
    self.findNode = function (allNodes, node) {
        if (allNodes.length > 0) {
            var nodeFound;
            for (var i = 0; i < allNodes.length; i++) {
                if (allNodes[i].Id() === node.Id()) {
                    nodeFound = allNodes[i];
                    break;
                }
                else {
                    var nodeTemp = self.findNode(allNodes[i].Nodes(), node);
                    if (nodeTemp) {
                        nodeFound = nodeTemp;
                        break;
                    }
                }
            }
            return nodeFound;
        }
    };
    self.loaded = function () {
        tabPage.DirtyFlag.reset();
        tabPage.IsLoading(false);
        self.refresh();
        self.toggleButtons();
        Bao.bindEvent('allcategory:refresh', self.refresh);
    };
}
;
Bao.inherit(AllCategoryViewModel, SubscriptionViewModel);
export default AllCategoryViewModel;